module.exports = __webpack_public_path__ + "img/pic_japan_01.6df394ca.jpg";